import store from '@/store';

const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const TopMenu = () => import(/* webpackChunkName: "base" */'@/components/common/TopMenu');
const User = () => import(/* webpackChunkName: "system" */'@/components/pages/system/base/User');
const Role = () => import(/* webpackChunkName: "system" */'@/components/pages/system/base/Role');
const Config = () => import(/* webpackChunkName: "system" */'@/components/pages/system/base/Config');
const Depart = () => import(/* webpackChunkName: "system" */'@/components/pages/system/base/Depart');
const Dictionary = () => import(/* webpackChunkName: "system" */'@/components/pages/system/base/dictionary');
const BusinessLeft = () => import(/* webpackChunkName: "system" */'@/components/pages/system/business/Left');
const BusinessOperate = () => import(/* webpackChunkName: "system" */'@/components/pages/system/business/BusinessOperate');
const Log = () => import(/* webpackChunkName: "system" */'@/components/pages/system/Log');
const Medium = () => import(/* webpackChunkName: "system" */'@/components/pages/system/notice/Medium');
const Record = () => import(/* webpackChunkName: "system" */'@/components/pages/system/notice/Record');
const Template = () => import(/* webpackChunkName: "system" */'@/components/pages/system/notice/Template');
const UserInfo = () => import(/* webpackChunkName: "system" */'@/components/common/UserInfo');

const baseRouterMapping = {
  'SYS_USER_QUERY': '/system/base/user',
  'SYS_ROLE_QUERY': '/system/base/role',
  'SYS_DEPART_QUERY': '/system/base/depart',
  'SYS_CONFIG_QUERY': '/system/base/config',
  'SYS_DIC_QUERY': '/system/base/dictionary'
};

const noticeRouterMapping = {
  'SYS_NOTICE_CONFIG_QUERY': '/system/notices/medium',
  'SYS_NOTICE_TEMPLATE_QUERY': '/system/notices/template',
  'SYS_NOTICE_INFO_QUERY': '/system/notices/record'
};

export default [
  {
    path: '/system',
    name: 'system',
    component: Layout,
    meta: {
      roles: [
        'SYS_USER_QUERY',
        'SYS_ROLE_QUERY',
        'SYS_CONFIG_QUERY',
        'SYS_DEPART_QUERY',
        'SYS_DIC_QUERY',
        'SYS_CI_TYPE_QUERY',
        'SYS_LOG_QUERY',
        'SYS_NOTICE_CONFIG_QUERY',
        'SYS_NOTICE_TEMPLATE_QUERY',
        'SYS_NOTICE_INFO_QUERY'
      ],
      title: '系统管理',
      icon: 'system',
    },
    children: [
      {
        path: 'base',
        name: 'base',
        redirect: () => {
          const roleIds = store.state.base.roleIds;
          let router = '/system/base/user';
          for (var item in baseRouterMapping) {
            if (roleIds.includes(item)) {
              router = baseRouterMapping[item];
              break;
            }
          }
          return router;
        },
        component: TopMenu,
        meta: {
          roles: [
            'SYS_USER_QUERY',
            'SYS_ROLE_QUERY',
            'SYS_CONFIG_QUERY',
            'SYS_DEPART_QUERY',
            'SYS_DIC_QUERY'
          ],
          title: '基础管理',
        },
        children: [
          {
            path: 'user',
            name: 'user',
            meta: {
              roles: ['SYS_USER_QUERY'],
              title: '账号管理',
              componentName: 'User',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '基础管理',
                  path: ''
                },
                {
                  name: '账号管理',
                  path: '/system/base/user'
                }
              ]
            },
            component: User
          },
          {
            path: 'role',
            name: 'role',
            meta: {
              roles: ['SYS_ROLE_QUERY'],
              title: '角色管理',
              componentName: 'Role',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '基础管理',
                  path: ''
                },
                {
                  name: '角色管理',
                  path: '/system/base/role'
                }
              ]
            },
            component: Role
          },
          {
            path: 'depart',
            name: 'depart',
            meta: {
              roles: ['SYS_DEPART_QUERY'],
              title: '机构管理',
              componentName: 'Depart',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '基础管理',
                  path: ''
                },
                {
                  name: '机构管理',
                  path: '/system/base/depart'
                }
              ]
            },
            component: Depart
          },
          {
            path: 'config',
            name: 'config',
            meta: {
              roles: ['SYS_CONFIG_QUERY'],
              title: '系统配置',
              componentName: 'Config',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '基础管理',
                  path: ''
                },
                {
                  name: '系统配置',
                  path: '/system/base/config'
                }
              ]
            },
            component: Config
          },
          {
            path: 'dictionary',
            name: 'dictionary',
            meta: {
              roles: ['SYS_DIC_QUERY'],
              title: '数据字典',
              componentName: 'Dictionary',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '基础管理',
                  path: ''
                },
                {
                  name: '数据字典',
                  path: '/system/base/dictionary'
                }
              ]
            },
            component: Dictionary
          },
        ]
      },
      {
        path: 'business',
        name: 'business',
        redirect: '/system/business/create-business',
        component: BusinessLeft,
        meta: {
          roles: ['SYS_CI_TYPE_QUERY'],
          title: '业务配置',
        },
        children: [
          {
            path: 'create-business',
            name: 'createBusiness',
            meta: {
              roles: [],
              title: '新增分类',
              componentName: 'BusinessOperate',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '业务配置',
                  path: ''
                },
                {
                  name: '新增分类',
                  path: '/system/business/create-business'
                }
              ]
            },
            component: BusinessOperate
          },
          {
            path: 'modify-business/:id',
            name: 'modifyBusiness',
            meta: {
              roles: [],
              title: '编辑分类',
              componentName: 'BusinessOperate',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '业务配置',
                  path: ''
                },
                {
                  name: '编辑分类',
                  path: '/system/business/modify-business/:id'
                }
              ]
            },
            component: BusinessOperate
          }
        ]
      },
      {
        path: 'notices',
        name: 'notices',
        redirect: () => {
          const roleIds = store.state.base.roleIds;
          let router = '/system/notices/medium';
          for (var item in noticeRouterMapping) {
            if (roleIds.includes(item)) {
              router = noticeRouterMapping[item];
              break;
            }
          }
          return router;
        },
        component: TopMenu,
        meta: {
          roles: [
            'SYS_NOTICE_CONFIG_QUERY',
            'SYS_NOTICE_TEMPLATE_QUERY',
            'SYS_NOTICE_INFO_QUERY'
          ],
          title: '通知管理',
        },
        children: [
          {
            path: 'medium',
            name: 'medium',
            meta: {
              roles: ['SYS_NOTICE_CONFIG_QUERY'],
              title: '通知参数',
              componentName: 'Medium',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '通知管理',
                  path: ''
                },
                {
                  name: '通知参数',
                  path: '/system/notices/medium'
                }
              ]
            },
            component: Medium
          },
          {
            path: 'template',
            name: 'template',
            meta: {
              roles: ['SYS_NOTICE_TEMPLATE_QUERY'],
              title: '通知模版',
              componentName: 'Template',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '通知管理',
                  path: ''
                },
                {
                  name: '通知模板',
                  path: '/system/notices/template'
                }
              ]
            },
            component: Template
          },
          {
            path: 'record',
            name: 'record',
            meta: {
              roles: ['SYS_NOTICE_INFO_QUERY'],
              title: '通知记录',
              componentName: 'Record',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '系统管理',
                  path: ''
                },
                {
                  name: '通知管理',
                  path: ''
                },
                {
                  name: '通知记录',
                  path: '/system/notices/record'
                }
              ]
            },
            component: Record
          },
        ]
      },
      {
        path: 'log',
        name: 'log',
        component: Log,
        meta: {
          roles: ['SYS_LOG_QUERY'],
          title: '日志中心',
          componentName: 'Log',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '系统管理',
              path: ''
            },
            {
              name: '日志中心',
              path: '/system/log'
            }
          ]
        }
      },
      // {
      //   path: 'user/info',
      //   name: 'userInfo',
      //   component: UserInfo,
      //   meta: {
      //     breadcrumb: [
      //       {
      //         name: '首页',
      //         path: '/home'
      //       },
      //       {
      //         name: '系统管理',
      //         path: ''
      //       },
      //       {
      //         name: '个人中心',
      //         path: 'user/info'
      //       }
      //     ]
      //   }
      // },
    ]
  },
  {
    path: '/user/info',
    name: 'info',
    meta: {
      title: '',
    },
    component: Layout,
    children: [{
      path: '',
      name: 'userInfo',
      component: UserInfo,
      meta: {
        breadcrumb: [
          {
            name: '首页',
            path: '/home'
          },
          {
            name: '个人中心',
            path: '/task'
          }
        ]
      }
    },
  ]
  }
];



// WEBPACK FOOTER //
// ./src/router/system.js